export interface ComposerKeyInput {
  key: string;
  metaKey: boolean;
  ctrlKey: boolean;
  isComposing: boolean;
}

/**
 * コンポーザーの送信キー判定。
 * Cmd+Enter（Mac）/ Ctrl+Enter（Windows）で送信。Enter / Shift+Enter は改行（送信しない）。
 * IME 変換中の Enter（漢字確定など）は除外する。
 */
export function isComposerSubmitKey({
  key,
  metaKey,
  ctrlKey,
  isComposing,
}: ComposerKeyInput): boolean {
  return key === 'Enter' && (metaKey || ctrlKey) && !isComposing;
}
